// extracted by mini-css-extract-plugin
export default {"label":"select_label__GuP5f","target":"select_target__yPhJh","disabled":"select_disabled__GBLGd","targetError":"select_targetError__k8pTl","error":"select_error__8fClo"};